import axios from 'axios';

// Base URL per le API: preferisce Vite env, fallback a /api per dev
const API_BASE = import.meta.env.VITE_API_BASE || (process.env.NODE_ENV === 'production' ? (process.env.VUE_APP_API_BASE || 'https://api.computerrivo.it') + '/api' : '/api');

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// Request interceptor: aggiunge token JWT se presente in localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwt_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Response interceptor: gestisce errori di autenticazione e notifica l'app
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response && error.response.status;
    if ([401, 403].includes(status)) {
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('user');
      try { window.dispatchEvent(new CustomEvent('auth:unauthorized')); } catch (e) { /* noop */ }
    }
    return Promise.reject(error);
  }
);

// Espone sia l'istanza axios `api` (con metodi .get/.post ecc.)
// sia helper specifici attaccati come proprietà su `api` per compatibilità
api.getServices = (params) => api.get('/services', { params });
api.getService = (id) => api.get(`/services/${id}`);
api.createService = (payload) => api.post('/services', payload);
api.updateService = (id, payload) => api.put(`/services/${id}`, payload);
api.deleteService = (id) => api.delete(`/services/${id}`);

api.getProviders = (params) => api.get('/providers', { params });
api.createProvider = (payload) => api.post('/providers', payload);
api.updateProvider = (id, payload) => api.put(`/providers/${id}`, payload);
api.deleteProvider = (id) => api.delete(`/providers/${id}`);

export default api;
